import React, { useState } from 'react'
import styled from 'styled-components';

const Items = styled.div`
    width: 100%;
    padding: 0.25rem;
`;

const Item = styled.div`
    width: 100%;
    padding: 0.25rem;
    border: 0.10rem solid #000;
    border-radius: 0.15rem;
    background-color: #F8F8F8;
`;

const Name = styled.div`
    display: inline-block;
    width: 55%;
    padding: 0.25rem;
`;

const NameWider = styled.div`
    display: inline-block;
    width: 90%;
    padding: 0.25rem;
`;

const Delete = styled.div`
    display: inline-block;
    width: 25%;
`;

const Change = styled.div`
    display: inline-block;
    width: 20%;
    padding: 0.25rem;
`;

const Button = styled.button`
    display: inline-block;
    border: 0.1rem solid #D90000;
    border-radius: 0.15rem;
    padding: 0.3rem 0.5rem 0.3rem 0.5rem;
    color: black;
    &:hover {
        background-color: red;
        color: white;
    }
`;

const ButtonChecked = styled.button`
    display: inline-block;
    border: 0.1rem solid #D90000;
    border-radius: 0.15rem;
    padding: 0.3rem 0.5rem 0.3rem 0.5rem;
    color: black;
    background: #FFCCCB;
    &:hover {
        background-color: red;
        color: white;
    }
`;

function AgendaTaskCheckbox({ setShow, setShowTimes, formValues, setFormValues, setTaskId }) {
    const [tasks, setTasks] = useState(formValues.taken);

    const handleChange = (id) => {
        setTaskId(id);
        setShowTimes(true);
        setShow(false);
    }

    const handleSelect = (id) => {
        const newTasks = tasks.map((task) => {
            if (task.id === id) {
                return { ...task, checked: !task.checked }
            } else {
                return { ...task }
            }
        })

        setTasks(newTasks);
        setFormValues({ ...formValues, "taken": newTasks })
    }

    return (
        <>
            <Items>
                {tasks.map(item => {
                    if (handleChange === undefined) {
                        return (
                            <Item key={item.id}>
                                <NameWider>
                                    {item.taak}
                                </NameWider>
                                <Delete>
                                    <Button onClick={() => handleSelect(item.id)}>X</Button>
                                </Delete>
                            </Item>
                        )
                    } else {
                        return (
                            <Item key={item.id}>
                                <Name>
                                    {item.taak}
                                </Name>
                                <Delete>
                                    {
                                        item.checked ?
                                            <ButtonChecked onClick={() => handleSelect(item.id)}>Verwijderen</ButtonChecked>
                                            :
                                            <Button onClick={() => handleSelect(item.id)}>Toevoegen</Button>
                                    }
                                </Delete>
                                <Change>
                                    {item.checked ? <Button onClick={() => handleChange(item.id)}>Tijden</Button> : null}
                                </Change>
                            </Item>
                        )
                    }
                })}
            </Items>
        </>
    )
}

export default AgendaTaskCheckbox
